export default __webpack_public_path__ + "static/media/LOGOerp2.5f3f825d.png";